// export const API_URL = "http://localhost:8000/api/3/";
// export const REPORT_FORM = "http://localhost:8000/3/";
// export const URL_IMAGE = "http://localhost:8000/";
// export const URL_LOGIN_LINE = "https://d68a-180-183-248-153.ngrok-free.app/2/";

// phutthaisong10902
// export const API_URL =
//   "https://loginsmedical.co.th/labonline/microservices/api/1/";
// export const REPORT_FORM =
//   "https://loginsmedical.co.th/labonline/microservices/1/";
// export const URL_IMAGE = "https://loginsmedical.co.th/labonline/microservices/";
// export const URL_LOGIN_LINE =
//   "https://loginsmedical.co.th/labonline/microservices/1/";

// kangkhoi10807
// export const API_URL =
//   "https://loginsmedical.co.th/labonline/microservices/api/2/";
// export const REPORT_FORM =
//   "https://loginsmedical.co.th/labonline/microservices/2/";
// export const URL_IMAGE = "https://loginsmedical.co.th/labonline/microservices/";
// export const URL_LOGIN_LINE =
//   "https://loginsmedical.co.th/labonline/microservices/2/";

// phlapphlachai10909
// export const API_URL =
//   "https://loginsmedical.co.th/labonline/microservices/api/3/";
// export const REPORT_FORM =
//   "https://loginsmedical.co.th/labonline/microservices/3/";
// export const URL_IMAGE = "https://loginsmedical.co.th/labonline/microservices/";
// export const URL_LOGIN_LINE =
//   "https://loginsmedical.co.th/labonline/microservices/3/";

// pakchongnana10890;
export const API_URL =
  "https://loginsmedical.co.th/labonline/microservices/api/4/";
export const REPORT_FORM =
  "https://loginsmedical.co.th/labonline/microservices/4/";
export const URL_IMAGE = "https://loginsmedical.co.th/labonline/microservices/";
export const URL_LOGIN_LINE =
  "https://loginsmedical.co.th/labonline/microservices/4/";

// thongphaphum11283;
// export const API_URL =
//   "https://loginsmedical.co.th/labonline/microservices/api/5/";
// export const REPORT_FORM =
//   "https://loginsmedical.co.th/labonline/microservices/5/";
// export const URL_IMAGE = "https://loginsmedical.co.th/labonline/microservices/";
// export const URL_LOGIN_LINE =
//   "https://loginsmedical.co.th/labonline/microservices/5/";

export const TOKEN = "labOnlineAuthen";
export const TOKEN_EXP = "labAuthenExpires";
export const USER = "labOnlineUser";
export const USER_GROUP = "labOnlineMenu";

export const VERSION = "V.671113";
